import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResultsLaptop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 301,
	height: 136,
	viewBox: "0 0 301 136",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M69.9345 30.7838V112.483C69.9345 113.297 69.774 114.104 69.4621 114.855C69.1503 115.607 68.6934 116.29 68.1177 116.864C67.5419 117.437 66.8587 117.891 66.1075 118.199C65.3563 118.506 64.5518 118.662 63.7406 118.656H53.1241C55.1922 118.656 57.1757 117.831 58.6382 116.363C60.1006 114.895 60.9221 112.904 60.9221 110.828C60.9221 108.752 60.1006 106.761 58.6382 105.293C57.1757 103.825 55.1922 103 53.1241 103H16.9523C14.8842 103 12.9007 102.176 11.4383 100.707C9.97587 99.2394 9.1543 97.2485 9.1543 95.1725C9.1543 93.0964 9.97587 91.1055 11.4383 89.6374C12.9007 88.1694 14.8842 87.3447 16.9523 87.3447H36.7147C38.783 87.3447 40.7665 86.5201 42.2288 85.052C43.6912 83.584 44.5129 81.5931 44.5129 79.5171C44.5129 77.4409 43.6912 75.45 42.2288 73.982C40.7665 72.5139 38.783 71.6893 36.7147 71.6893H16.9523C14.8842 71.6893 12.9007 70.8646 11.4383 69.3966C9.97587 67.9286 9.1543 65.9376 9.1543 63.8615C9.1543 61.7855 9.97587 59.7946 11.4383 58.3265C12.9007 56.8585 14.8842 56.0338 16.9523 56.0338H42.4073C44.4756 56.0338 46.4591 55.2092 47.9214 53.7411C49.3838 52.2731 50.2055 50.2822 50.2055 48.206C50.2055 46.13 49.3838 44.1391 47.9214 42.6711C46.4591 41.2031 44.4756 40.3784 42.4073 40.3784H27.6803C25.612 40.3784 23.6286 39.5537 22.1662 38.0857C20.7037 36.6177 19.8822 34.6267 19.8822 32.5506C19.8822 30.4746 20.7037 28.4837 22.1662 27.0156C23.6286 25.5476 25.612 24.7229 27.6803 24.7229H63.7406C65.3602 24.7109 66.9189 25.3406 68.0787 26.4755C69.2383 27.6102 69.9053 29.1584 69.9345 30.7838Z",
			fill: "url(#paint0_linear_33423_13628)",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M227.963 33.9638V114.335C227.963 115.133 228.12 115.923 228.426 116.661C228.731 117.398 229.179 118.067 229.744 118.631C230.307 119.195 230.977 119.642 231.715 119.946C232.452 120.251 233.243 120.407 234.039 120.405H244.546C242.505 120.405 240.549 119.594 239.106 118.151C237.663 116.707 236.854 114.749 236.854 112.708C236.854 110.666 237.663 108.708 239.106 107.265C240.549 105.821 242.505 105.01 244.546 105.01H280.198C282.239 105.01 284.195 104.199 285.638 102.756C287.081 101.312 287.89 99.3545 287.89 97.3131C287.89 95.2715 287.081 93.3138 285.638 91.8702C284.195 90.4266 282.239 89.6157 280.198 89.6157H260.735C258.694 89.6157 256.738 88.8047 255.295 87.3612C253.852 85.9176 253.042 83.9598 253.042 81.9184C253.042 79.8768 253.852 77.9191 255.295 76.4755C256.738 75.0319 258.694 74.221 260.735 74.221H280.198C282.239 74.221 284.195 73.41 285.638 71.9665C287.081 70.5229 287.89 68.5651 287.89 66.5237C287.89 64.4821 287.081 62.5244 285.638 61.0808C284.195 59.6372 282.239 58.8263 280.198 58.8263H255.108C253.067 58.8263 251.111 58.0154 249.668 56.5718C248.225 55.1282 247.416 53.1704 247.416 51.1289C247.416 49.0874 248.225 47.1297 249.668 45.6861C251.111 44.2425 253.067 43.4316 255.108 43.4316H269.647C271.689 43.4316 273.645 42.6207 275.088 41.1771C276.53 39.7335 277.34 37.7757 277.34 35.7342C277.34 33.6928 276.53 31.7349 275.088 30.2914C273.645 28.8478 271.689 28.0369 269.647 28.0369H234.039C232.453 28.0336 230.929 28.6521 229.792 29.76C228.658 30.8679 228 32.377 227.963 33.9638Z",
			fill: "url(#paint1_linear_33423_13628)",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.535 130.003H92.3027V127.252H218.535C218.9 127.252 219.25 127.397 219.508 127.655C219.766 127.913 219.911 128.263 219.911 128.627C219.911 128.992 219.766 129.342 219.508 129.6C219.25 129.858 218.9 130.003 218.535 130.003Z",
			fill: "#426572"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.6559 130.003H78.938C78.5732 130.003 78.2234 129.858 77.9654 129.6C77.7075 129.342 77.5625 128.992 77.5625 128.627C77.5625 128.263 77.7075 127.913 77.9654 127.655C78.2234 127.397 78.5732 127.252 78.938 127.252H86.6559C87.0207 127.252 87.3705 127.397 87.6285 127.655C87.8865 127.913 88.0314 128.263 88.0314 128.627C88.0314 128.992 87.8865 129.342 87.6285 129.6C87.3705 129.858 87.0207 130.003 86.6559 130.003Z",
			fill: "#426572"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.9303 130.003H71.4712C71.1064 130.003 70.7566 129.858 70.4986 129.6C70.2407 129.342 70.0957 128.992 70.0957 128.627C70.0957 128.263 70.2407 127.913 70.4986 127.655C70.7566 127.397 71.1064 127.252 71.4712 127.252H73.9303C74.2951 127.252 74.6449 127.397 74.9029 127.655C75.1609 127.913 75.3058 128.263 75.3058 128.627C75.3058 128.992 75.1609 129.342 74.9029 129.6C74.6449 129.858 74.2951 130.003 73.9303 130.003Z",
			fill: "#426572"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.799 130.003H224V127.252H262.799C263.163 127.252 263.514 127.397 263.772 127.655C264.03 127.913 264.174 128.263 264.174 128.627C264.174 128.992 264.03 129.342 263.772 129.6C263.514 129.858 263.163 130.003 262.799 130.003Z",
			fill: "#C3C3C3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.4376 130.003H25.6367V127.252H64.4376C64.8024 127.252 65.1522 127.397 65.4102 127.655C65.6682 127.913 65.8131 128.263 65.8131 128.627C65.8131 128.992 65.6682 129.342 65.4102 129.6C65.1522 129.858 64.8024 130.003 64.4376 130.003Z",
			fill: "#C3C3C3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.7317 22.6326H218.057C220.608 22.6326 223.523 23.1957 225.327 24.9989C227.131 26.8024 227.676 29.6978 227.677 32.2487V123.724H67.1113V32.2487C67.1124 29.6978 67.5788 26.5252 69.3829 24.7218C71.187 22.9185 74.181 22.6326 76.7317 22.6326Z",
			fill: "#C3C3C3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.22 29.5767H73.2422V114.669H220.22V29.5767Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.949 124.994H65.8438V28.1475C65.8461 26.3487 66.5616 24.6244 67.8334 23.3524C69.1053 22.0805 70.8298 21.365 72.6283 21.3629H222.165C223.963 21.365 225.688 22.0805 226.96 23.3524C228.231 24.6244 228.947 26.3487 228.949 28.1475V124.994ZM68.3832 122.455H226.41V28.1475C226.409 27.0219 225.961 25.9428 225.165 25.1469C224.369 24.351 223.29 23.9034 222.165 23.9024H72.6283C71.5029 23.9034 70.4237 24.351 69.6278 25.1469C68.8321 25.9428 68.3843 27.0219 68.3832 28.1475V122.455Z",
			fill: "#35363A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.8613 120.695H252.234V121.371C252.234 123.56 251.364 125.659 249.817 127.206C248.268 128.754 246.169 129.624 243.981 129.624H55.1146C52.9258 129.624 50.8265 128.754 49.2787 127.206C47.7309 125.659 46.8613 123.56 46.8613 121.371V120.695Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M251.182 125.001C250.731 126.175 249.933 127.184 248.896 127.896C247.859 128.608 246.63 128.989 245.373 128.988H52.4415C51.1845 128.988 49.9569 128.607 48.9205 127.895C47.8842 127.183 47.0881 126.174 46.6367 125.001H251.182Z",
			fill: "#E3DFE9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.02 130.574H54.1558C51.6309 130.571 49.2104 129.567 47.4252 127.781C45.6397 125.996 44.6356 123.575 44.6328 121.051V119.106H252.545V121.051C252.543 123.576 251.538 125.997 249.751 127.782C247.965 129.567 245.544 130.571 243.02 130.574ZM47.1956 121.645C47.3445 123.388 48.1421 125.012 49.4305 126.195C50.7191 127.378 52.4044 128.034 54.1537 128.034H243.02C244.77 128.034 246.454 127.378 247.743 126.195C249.032 125.012 249.83 123.388 249.978 121.645H47.1956Z",
			fill: "#35363A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 117.05,
			y: 47,
			width: 61,
			height: 61,
			rx: 2.70835,
			fill: "#EEECF2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_33423_13628)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M138.385 94.0174C138.718 92.016 139.826 90.1898 141.508 88.8705C143.189 87.5509 145.332 86.8254 147.549 86.8254C149.766 86.8254 151.909 87.5509 153.591 88.8705C155.272 90.1898 156.38 92.016 156.714 94.0174",
					stroke: "#C8BADF",
					strokeWidth: 2.64286,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.518 81.4872C163.16 84.0204 161.121 85.9907 158.634 86.2162C151.163 86.8941 143.937 86.8941 136.465 86.2162C133.978 85.9907 131.939 84.0204 131.581 81.4872C130.849 76.304 130.849 71.4029 131.581 66.2197C131.939 63.6865 133.978 61.7162 136.465 61.4906C143.937 60.8127 151.163 60.8127 158.634 61.4906C161.121 61.7162 163.16 63.6865 163.518 66.2197C164.251 71.4029 164.251 76.304 163.518 81.4872Z",
					fill: "#DCD7E4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.518 81.4872C163.16 84.0204 161.121 85.9907 158.634 86.2162C151.163 86.8941 143.937 86.8941 136.465 86.2162C133.978 85.9907 131.939 84.0204 131.581 81.4872C130.849 76.304 130.849 71.4029 131.581 66.2197C131.939 63.6865 133.978 61.7162 136.465 61.4906C143.937 60.8127 151.163 60.8127 158.634 61.4906C161.121 61.7162 163.16 63.6865 163.518 66.2197C164.251 71.4029 164.251 76.304 163.518 81.4872Z",
					stroke: "#C8BADF",
					strokeWidth: 2.64286,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.105 43.8187H220.751V31.1026L217.984 30.594H91.3069H78.8685H74.2617V43.8187H76.105Z",
			fill: "#E5E5E5"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				opacity: .5,
				d: "M139.632 30.0796L116.029 118.949H104.143L127.746 30.0796H139.632Z",
				fill: "#F1EFF4"
			}), /* @__PURE__ */ _jsx("path", {
				opacity: .5,
				d: "M169.928 30.0796L146.327 118.949H121.4L145.004 30.0796H169.928Z",
				fill: "#F1EFF4"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M223.048 112.112C223.048 113.943 221.564 115.427 219.733 115.427H75.0536C73.2226 115.427 71.7383 113.943 71.7383 112.112V31.6938C71.7383 29.8628 73.2226 28.3785 75.0536 28.3785H219.733C221.564 28.3785 223.048 29.8628 223.048 31.6938V112.112ZM74.2777 109.572C74.2777 111.403 75.762 112.888 77.593 112.888H217.193C219.024 112.888 220.508 111.403 220.508 109.572V34.2333C220.508 32.4023 219.024 30.918 217.193 30.918H77.593C75.762 30.918 74.2777 32.4023 74.2777 34.2333V109.572Z",
			fill: "#35363A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.0107 40.0765C88.6094 40.3449 88.1371 40.4881 87.6545 40.4881C87.3338 40.4881 87.0166 40.4251 86.7203 40.3022C86.4243 40.1794 86.1547 39.9995 85.9281 39.773C85.7015 39.5465 85.5216 39.2773 85.3988 38.981C85.2759 38.6846 85.2129 38.3672 85.2129 38.0465C85.2129 37.5636 85.3561 37.0918 85.6245 36.6902C85.893 36.2886 86.2739 35.9755 86.7203 35.7909C87.1662 35.6058 87.6573 35.558 88.1307 35.6521C88.6042 35.7462 89.0394 35.9787 89.3808 36.3201C89.7223 36.6615 89.9548 37.097 90.049 37.5704C90.1431 38.0442 90.0948 38.5343 89.9102 38.9806C89.7255 39.4268 89.4123 39.8081 89.0107 40.0765Z",
			fill: "#FFBD2E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.8939 40.0765C95.4926 40.3449 95.0207 40.4881 94.5377 40.4881C94.217 40.4881 93.8995 40.4251 93.6031 40.3022C93.3067 40.1794 93.0375 39.9995 92.8109 39.773C92.5843 39.5465 92.4044 39.2773 92.2816 38.9809C92.1587 38.6846 92.0957 38.3672 92.0957 38.0465C92.0957 37.5635 92.2389 37.0917 92.5074 36.6901C92.7758 36.2885 93.1571 35.9754 93.6031 35.7908C94.049 35.6061 94.5401 35.5579 95.0135 35.652C95.487 35.7461 95.9222 35.9786 96.2637 36.32C96.6051 36.6614 96.8376 37.0965 96.9318 37.5699C97.0259 38.0437 96.9777 38.5343 96.793 38.9805C96.6083 39.4268 96.2956 39.8081 95.8939 40.0765Z",
			fill: "#27C940"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.1279 40.0765C81.7262 40.3449 81.2547 40.4881 80.7717 40.4881C80.1243 40.4881 79.5032 40.2308 79.0453 39.773C78.5874 39.3151 78.3301 38.6942 78.3301 38.0465C78.3301 37.5635 78.4733 37.0917 78.7417 36.6901C79.0102 36.2885 79.3915 35.9758 79.8375 35.7908C80.2834 35.6061 80.7744 35.5579 81.2479 35.652C81.7214 35.7461 82.1566 35.9786 82.498 36.32C82.8395 36.6614 83.072 37.0965 83.1662 37.5703C83.2603 38.0441 83.212 38.5347 83.0273 38.9809C82.8427 39.4272 82.5295 39.8081 82.1279 40.0765Z",
			fill: "#FF6058"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_33423_13628",
				x1: 68.8294,
				y1: 72.2418,
				x2: -10.1849,
				y2: 72.2418,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C3F6EE" }), /* @__PURE__ */ _jsx("stop", {
					offset: .38,
					stopColor: "#C6EBFD"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_33423_13628",
				x1: 230.978,
				y1: 71.3564,
				x2: 294.521,
				y2: 70.2513,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C3F6EE" }), /* @__PURE__ */ _jsx("stop", {
					offset: .38,
					stopColor: "#C6EBFD"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_33423_13628",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 37,
					height: 37,
					fill: "white",
					transform: "translate(129.05 59)"
				})
			})
		] })
	]
});
export default SvgNoResultsLaptop;
